import Form from './form.js';
import AnalyticsHelper from '../utils/analytics-helper.js';
import { getProductDivision } from '../utils/dom.js';
import { pushEmailAnalytics } from '../utils/ecomm-email-analytics';

export default class FormBuilder {
    constructor(el) {
        this.productDivision = getProductDivision();
        this.el = el;
        this.loader = el.querySelector('.form_builder_wrapper_loader');
        this.confirmation = el.dataset.confirmation;
        this.callbacks = {
            onSubmit: this.onSubmit.bind(this),
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
            onUpdate: this.onUpdate.bind(this),
        };
        this.form = new Form(el.querySelector('.form_builder'), this.callbacks);
        this.ecommFormName = el.dataset.ecommFormName;
        this.analytics = {
            event: el.dataset.event || 'Form Builder 2',
            eventUpdate: el.dataset.eventUpdate || 'Form Builder 2',
            eventComplete: el.dataset.eventComplete || 'Form Builder 2',
            eventCategory: el.dataset.eventCategory || 'Form Builder 2',
            formName: el.dataset.formName || '',
            businessUnit: el.dataset.businessUnit || '',
            countryCode: el.dataset.countryCode || '',
            modelSelected: el.dataset.modelSelected || this.fetchModelValue(el.querySelector('.form_builder .parsys')),
        };
        this.onEntry();
    }

    setUserContext(formItem) {
        const userContextData = formItem.dataset.userContextData;

        if (this.productDivision && userContextData) {
            const obj = {
                [this.productDivision]: {
                    ...JSON.parse(userContextData),
                },
            };

            HONDA.UserContext?.setData(obj);
        }
    }

    fetchModelValue(formParsys) {
        const modelValue = formParsys?.querySelector('input[name="model"]')?.value;
        return modelValue ? modelValue : '';
    }

    onEntry() {
        AnalyticsHelper.push({
            event: this.analytics.event,
            eventCategory: this.analytics.eventCategory,
            eventLabel: `${this.analytics.formName} | ${this.analytics.modelSelected} | Top | ${window.location.href} | ${this.analytics.businessUnit} | ${this.analytics.countryCode}`,
            eventAction: 'Entry',
            actionType: 'Entry',
            moduleName: this.analytics.formName,
            modelSelected: this.analytics.modelSelected,
            inPageLocation: 'Top',
            destinationURL: window.location.href,
            businessUnit: this.analytics.businessUnit,
            countryCode: this.analytics.countryCode,
        });
    }

    onSubmit() {
        AnalyticsHelper.push({
            event: this.analytics.eventComplete,
            eventCategory: this.analytics.eventCategory,
            eventLabel: `${this.analytics.formName} | Submit | Internal | ${this.analytics.modelSelected} | Bottom | ${this.confirmation} | ${this.analytics.businessUnit} | ${this.analytics.countryCode}`,
            eventAction: 'Completion',
            actionType: 'Completion',
            moduleName: this.analytics.formName,
            clickText: 'Submit' || '',
            clickType: 'Internal',
            modelSelected: this.analytics.modelSelected,
            inPageLocation: 'Bottom',
            destinationURL: this.confirmation || '',
            businessUnit: this.analytics.businessUnit,
            countryCode: this.analytics.countryCode,
        });
    }

    onSuccess(result, body) {
        AnalyticsHelper.push({
            event: this.analytics.event,
            eventCategory: this.analytics.eventCategory,
            eventLabel: 'Form',
            eventAction: 'Form Submit Success',
        });

        pushEmailAnalytics({
            formName: this.ecommFormName, 
            model: this.analytics.modelSelected, 
            sendName: true, 
            personalDetails: {
                email: body.get('email'),
                firstName: body.get('firstName'), 
                lastName: body.get('lastName'),
            }
        });
        this.setUserContext(this.el.querySelector('.form_builder'));
        window.location.href = this.confirmation;
    }

    onError() {
        AnalyticsHelper.push({
            event: this.analytics.event,
            eventCategory: this.analytics.eventCategory,
            eventLabel: 'Form',
            eventAction: 'Form Submit Error',
        });
        this.form.showError();
    }

    onUpdate(field, valid) {
        if (!this.updated) {
            this.updated = true;
            AnalyticsHelper.push({
                event: this.analytics.eventUpdate,
                eventCategory: this.analytics.eventCategory,
                eventLabel: `${this.analytics.formName} | ${field.label} | Internal | ${this.analytics.modelSelected} | Top | ${window.location.href} | ${this.analytics.businessUnit} | ${this.analytics.countryCode}`,
                eventAction: 'Start',
                actionType: 'Start',
                moduleName: this.analytics.formName,
                clickText: `${field.label}`,
                clickType: 'Internal',
                modelSelected: this.analytics.modelSelected,
                inPageLocation: 'Top',
                destinationURL: window.location.href,
                businessUnit: this.analytics.businessUnit,
                countryCode: this.analytics.countryCode,
            });
        }
        if (!valid) {
            AnalyticsHelper.push({
                event: this.analytics.event,
                eventCategory: this.analytics.eventCategory,
                eventLabel: field.label,
                eventAction: 'Form Validation Error',
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.form_builder_wrapper').forEach((el) => new FormBuilder(el));
});
